import { zodValidator } from '@tanstack/zod-adapter';
import { Outlet, redirect } from '@tanstack/react-router';
import { PermissionRoute } from '@anytag/app';
import { adminStaffRoles, adminStaffTalentAgencyRoles } from '@anytag/shared-constants';
import {
  YoutubeCMS,
  YoutubeCMSInvoices,
  YoutubeCMSChannelDetails,
  YoutubeCMSConfirmedRevenue,
  YoutubeCMSEstimatedRevenue
} from '@anytag/app';
import {
  YoutubeCMSSearchSchema,
  YoutubeCMSInvoicesSearchSchema,
  YoutubeCMSChannelDetailsSearchSchema
} from '@anytag/shared-organisms';

import { PartialRouter } from '../../types';

export const YoutubeCmsRouter = {
  '/_private-routes/youtube-cms': [() => <Outlet />, {}],
  '/_private-routes/youtube-cms/': [
    () => <Outlet />,
    {
      beforeLoad: () => {
        throw redirect({ to: '/youtube-cms/revenue' });
      }
    }
  ],
  '/_private-routes/youtube-cms/revenue': [
    () => <PermissionRoute permissions={adminStaffTalentAgencyRoles} element={<YoutubeCMS />} />,
    {}
  ],
  '/_private-routes/youtube-cms/revenue/': [
    YoutubeCMSEstimatedRevenue,
    { validateSearch: zodValidator(YoutubeCMSSearchSchema) }
  ],
  '/_private-routes/youtube-cms/revenue/$cmsChannelId': [
    YoutubeCMSChannelDetails,
    { validateSearch: zodValidator(YoutubeCMSChannelDetailsSearchSchema) }
  ],
  '/_private-routes/youtube-cms/revenue/confirmed': [
    () => <PermissionRoute permissions={adminStaffRoles} element={<YoutubeCMSConfirmedRevenue />} />,
    { validateSearch: zodValidator(YoutubeCMSSearchSchema) }
  ],
  '/_private-routes/youtube-cms/invoices': [
    () => <PermissionRoute permissions={adminStaffRoles} element={<YoutubeCMSInvoices />} />,
    { validateSearch: zodValidator(YoutubeCMSInvoicesSearchSchema) }
  ]
} as const satisfies PartialRouter;
